import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({
  providedIn: 'root'
})
export class PurorgService extends BaseService{
  constructor(http: HttpClient) {
    super(http);
  }
  private url = 'api/purorg';

  getUrl(): string {
    return this.url;
  }
  /**
   * 根据code获取采购组织
   * @param type
   * @returns {Observable<any|any>}
   */
  getWithPurorgCode(purorgCode):Observable<any> {
    const url = `${this.getUrl()}/search-with-purorgCode`;
    return this.http.get<any>(url, {params: {purorgCode: purorgCode}}).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`))
    );
  }
}
